import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import nl from "./locales/nl.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en }, nl: { translation: nl } },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "nl"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage"], lookupLocalStorage: "cd_lang", caches: ["localStorage"] },
  });

// Garde document.documentElement.lang synchronisé avec la langue de l'app (a11y/SEO),
// sans réactiver l'auto-traduction du navigateur (translate="no" reste défini dans index.html).
const _applyLang = (lng) => { try { document.documentElement.lang = (lng || "fr").split("-")[0]; } catch (e) {} };
_applyLang(i18n.language);
i18n.on("languageChanged", _applyLang);

export default i18n;
